<template>
  <div class="min-h-screen flex">
    <!-- 좌측 브랜딩 섹션 -->
    <div class="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 to-primary-800 relative">
      <div class="flex flex-col justify-center px-12 text-white">
        <div class="mb-8">
          <RouterLink
            to="/"
            class="inline-flex items-center space-x-3 mb-6 hover:opacity-90"
            aria-label="Seatisfy 홈"
          >
            <div class="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
              <span class="text-primary-600 font-bold text-xl">S</span>
            </div>
            <span class="text-3xl font-bold">Seatisfy</span>
          </RouterLink>
          <h1 class="text-4xl font-bold mb-4">
            새로운 좌석 예약 경험
          </h1>
          <p class="text-xl text-primary-100 mb-8">
            언제 어디서나 간편하게 좌석을 예약하고 관리하세요. 
            현대적이고 안전한 예약 시스템을 제공합니다.
          </p>
        </div>

        <!-- 특징들 -->
        <div class="space-y-4">
          <div class="flex items-center space-x-3">
            <div class="w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center">
              <CheckIcon class="w-4 h-4 text-white" />
            </div>
            <span class="text-lg">실시간 좌석 현황 확인</span>
          </div>
          <div class="flex items-center space-x-3">
            <div class="w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center">
              <CheckIcon class="w-4 h-4 text-white" />
            </div>
            <span class="text-lg">간편한 예약 및 취소</span>
          </div>
          <div class="flex items-center space-x-3">
            <div class="w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center">
              <CheckIcon class="w-4 h-4 text-white" />
            </div>
            <span class="text-lg">안전한 데이터 보호</span>
          </div>
        </div>
      </div>

      <!-- 배경 패턴 -->
      <div class="absolute inset-0 opacity-10">
        <div class="absolute inset-0 bg-repeat" style="background-image: url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"></div>
      </div>
    </div>

    <!-- 우측 인증 폼 섹션 -->
    <div class="flex-1 lg:w-1/2 flex flex-col justify-center px-6 py-12 lg:px-12">
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <div class="mb-6">
          <Breadcrumbs />
        </div>
        <!-- 모바일에서만 보이는 로고 -->
        <div class="lg:hidden flex justify-center mb-8">
          <RouterLink
            to="/"
            class="inline-flex items-center space-x-2 hover:opacity-90"
            aria-label="Seatisfy 홈"
          >
            <div class="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center">
              <span class="text-white font-bold text-lg">S</span>
            </div>
            <span class="text-2xl font-bold text-gray-900">Seatisfy</span>
          </RouterLink>
        </div>

        <!-- 라우터 뷰 (인증 관련 컴포넌트들) -->
        <RouterView />

        <!-- 추가 링크 -->
        <div class="mt-8 text-center">
          <RouterLink
            to="/"
            class="text-sm text-primary-600 hover:text-primary-500 font-medium"
          >
            ← 메인 페이지로 돌아가기
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
import { CheckIcon } from '@heroicons/vue/24/solid'
import Breadcrumbs from '@/components/common/Breadcrumbs.vue'
</script>
